var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27886 9.59631C6.79706 8.39457 6.74497 7.06333 7.13139 5.82761C7.51781 4.5919 8.31905 3.5275 9.39965 2.81434C10.4803 2.10118 11.774 1.783 13.0621 1.91358C14.3502 2.04416 15.5537 2.61549 16.4693 3.531C17.3848 4.44651 17.9561 5.65005 18.0867 6.93817C18.2172 8.22629 17.8991 9.52 17.1859 10.6006C16.4727 11.6812 15.4083 12.4824 14.1726 12.8689C12.9369 13.2553 11.6057 13.2032 10.4039 12.7214L10.404 12.7213L9.37524 13.75H7.50024V15.625H5.62524V17.5H2.50024V14.375L7.27899 9.59625L7.27886 9.59631Z",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 6.875C14.5803 6.875 15 6.45527 15 5.9375C15 5.41973 14.5803 5 14.0625 5C13.5447 5 13.125 5.41973 13.125 5.9375C13.125 6.45527 13.5447 6.875 14.0625 6.875Z",
    fill: "#677791"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.838260be7844b238050ea4bde6d718dc.svg";
export { ForwardRef as ReactComponent };